import styled from "styled-components";

interface Props extends React.HTMLAttributes<HTMLElement> {
  direction?: "row" | "column";
}

interface RowProps {
  direction?: "row" | "column";
}

const Row = styled.div<RowProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: ${(props) => (props.direction ? props.direction : "row")};
  }
`;

// const Row = ({ direction }: Props) => {
//   if (!direction) {
//     return <RowWrapper />;
//   } else {
//     return <RowWrapper direction={direction} />;
//   }
// };

export default Row;
